import { Badge, Card, Group, List, Stack, Text } from "@mantine/core";
import { STATUS_CONFIG } from "./AvaliacaoIAModalContent";
import useGetAvaliacoesIA from "../../hooks/useGetAvaliacoesIA";

type AvaliacaoIASectionProperties = {
  ideia: TIdeia;
};

/**
 *
 * @param root0
 * @param root0.ideia
 */
function AvaliacaoIASection({ ideia }: AvaliacaoIASectionProperties): JSX.Element | null {
  const { data: avaliacao, isLoading, error } = useGetAvaliacoesIA(ideia);

  if (isLoading) {
    return (
      <Card withBorder>
        <Text size="sm">Carregando avaliação IA...</Text>
      </Card>
    );
  }

  if (error) {
    return (
      <Card withBorder>
        <Text size="sm">Não foi possivel carregar a avaliação IA.</Text>
      </Card>
    );
  }

  if (!avaliacao) {
    return (
      <Card withBorder>
        <Text size="sm">Nenhuma avaliação IA encontrada.</Text>
      </Card>
    );
  }

  return (
    <Card withBorder>
      <Stack gap="xs">
        <Group justify="space-between">
          <Text fw={600}>Avaliação IA</Text>
          <Badge color={STATUS_CONFIG[avaliacao.status].color}>{STATUS_CONFIG[avaliacao.status].label}</Badge>
        </Group>
        <Group gap="xl">
          <Text size="sm">Score: {avaliacao.scoreCalculado}</Text>
          <Text size="sm">Conforme regulamento: {avaliacao.conformeRegulamento ? "sim" : "nao"}</Text>
        </Group>

        {avaliacao.resultadoJson?.avaliacao?.length ? (
          <List spacing="xs" size="sm">
            {avaliacao.resultadoJson.avaliacao.map((item) => (
              <List.Item key={item.criterio}>
                <Text size="sm" fw={500}>
                  {item.criterio}: {item.nota}
                </Text>
                <Text size="sm">{item.justificativa}</Text>
              </List.Item>
            ))}
          </List>
        ) : null}

        {avaliacao.resultadoJson?.flags?.length ? (
          <Text size="sm">Flags: {avaliacao.resultadoJson.flags.join(", ")}</Text>
        ) : null}

        {avaliacao.resultadoJson?.perguntas?.length ? (
          <Stack gap={4}>
            <Text size="sm">Perguntas:</Text>
            <List spacing="xs" size="sm">
              {avaliacao.resultadoJson.perguntas.map((pergunta) => (
                <List.Item key={pergunta}>{pergunta}</List.Item>
              ))}
            </List>
          </Stack>
        ) : null}
      </Stack>
    </Card>
  );
}

export default AvaliacaoIASection;
